import type { home as homeEn } from '../en/home';

export const home: typeof homeEn = {
  eyebrow: '小小游戏，大大乐趣',
  eyebrowPhone: '玩一会儿',
  title: '玩一会儿，\n乐一整天。',
  subtitle: '画画、猜猜、找找、吹吹牛、记一记。一个人玩，或和好友一起。',
  subtitlePhone: '好游戏，配好友。',
};
